import { render, staticRenderFns } from "./ViewerXls.vue?vue&type=template&id=96da47a8&"
import script from "./ViewerXls.vue?vue&type=script&lang=js&"
export * from "./ViewerXls.vue?vue&type=script&lang=js&"
import style0 from "./ViewerXls.vue?vue&type=style&index=0&id=96da47a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports